




































































import axios from 'axios'
import { Component, Vue } from 'vue-property-decorator'

Component.registerHooks([
  'beforeRouteUpdate'
])

@Component
export default class News extends Vue {
  loading:Boolean = true
  curr:object = {}
  prev:object = {}
  next:object = {}
  latestk:Array<object> = []
  breadcrumbItems:Array<object> = [
    {
      text: 'News Archive',
      to: { name: 'Home' }
    }
  ]

  getData (id: string) {
    this.loading = true
    axios.get('/api/news/id/' + id).then(
      response => {
        var temp = response.data
        var session = temp['curr']['session']
        this.curr = temp['curr']
        this.prev = temp['prev']
        this.next = temp['next']
        this.breadcrumbItems.push({
          text: 'Session ' + session
        })
        this.loading = false
      }
    )
    axios.get('/api/news/latest').then(
      response => { this.latestk = response.data }
    )
  }

  beforeRouteUpdate (to:any, from:any, next:any) {
    this.getData(to.params.id)
    this.breadcrumbItems.pop()
    next()
  }

  mounted () {
    this.getData(this.$route.params.id)
  }
}
